import React from "react";
import { Typography, Paper, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

function Pricing() {
    return (
        <Box
            sx={{
                backgroundColor: "#f4f9ff",
                minHeight: "100vh",
                p: 2,
                display: "flex",
                flexDirection: "column",
                gap: 3,
            }}
        >
            <div className="header">
                <img src="/logo.png" alt="Logo" className="logo" />
                <div className="heading-text">
                    <br />
                    <h1 className="title">Smart Parking App</h1>
                    <p className="caption">"Empowering Digital India .."</p>
                </div>
            </div>
            <h1 className="title">Parking Pricing Details</h1>

            <Paper
                elevation={3}
                sx={{
                    p: 3,
                    borderRadius: 4,
                    backgroundColor: "#ffffff",
                    maxWidth: 600,
                    width: "90%",
                    mx: "auto",
                }}
            >
                <Typography variant="body1" gutterBottom>
                    This page provides the official pricing details for parking facilities across all zones within the Kalimpong Municipality area.
                </Typography>

                {/* Hourly Pricing Table */}
                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                    Hourly Pricing
                </Typography>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>Parking Zone</strong></TableCell>
                                <TableCell align="right"><strong>Price per Hour</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>Damber Chowk Zone</TableCell>
                                <TableCell align="right">₹10.00</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>9th Mile Zone</TableCell>
                                <TableCell align="right">₹12.00</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>10th Mile Zone</TableCell>
                                <TableCell align="right">₹13.00</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <hr />
                {/* Daily Pricing */}
                <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
                    Daily Pricing
                </Typography>
                <Typography variant="body1">
                    The parking cost for one day in all Zone within the Kalimpong Municipality area is ₹200.00.
                </Typography>
                <hr />

                {/* Monthly Pricing */}
                <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
                    Monthly Pricing
                </Typography>
                <Typography variant="body1">
                    The monthly parking fee for all zones within the Kalimpong jurisdiction is ₹2500.00.
                </Typography>
                <br />
            </Paper>
            <br />
        </Box>
    );
}

export default Pricing;